import React from "react";
import { classNames } from "maven-lib/dist/utils/misc";
import { HbListItem, HbListItemProps } from "./HbListItem";

type HbListCellProps = HbListItemProps & { key: string | number };

interface HbListProps {
  title?: string;
  items: Array<HbListCellProps>;
  fontSize?: "SMALL" | "MEDIUM" | "LARGE";
}

export function HbList(props: HbListProps) {
  const { title, items, fontSize } = props;

  return (
    <>
      <div className={classNames("hb-list")}>
        {!!title && (
          <div
            className={classNames("hb-list-title", {
              "font--small": fontSize === "SMALL",
              "font--medium": fontSize === "MEDIUM",
              "font--large": fontSize === "LARGE",
            })}
          >
            {title}
          </div>
        )}
        <div className="hb-list-items">
          {items.map((item) => (
            <React.Fragment key={item.key}>
              <HbListItem {...item} fontSize={fontSize} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
}
